---
id: resume-analyzer
title: Resume analyzer service
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - resume
  - analysis
  - microservice
---

## Product Overview

### Who it serves

This microservice powers resume analysis features that score and review resume content for consumer and enterprise workflows.

### Primary workflow

Clients submit analysis requests for resume sections or full resumes, and the service returns scores while persisting analysis results.

### Business rules

Analysis respects the user’s subscription plan, enforces ownership checks for non-enterprise traffic, and records activity events for scoring outcomes.

### Outcomes

Resume analysis results and scores are saved for later retrieval and displayed to end users in resume review flows.

### Out of scope

Resume editing, file parsing, and document generation are handled by other services.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/resume-analyzer-api-docs)

## Technical Overview

### Architecture flow

Routes in `apps/micro-services/resume-analyzer/pkg/routes/routes.go` expose `/v1/analysis` and enterprise variants, invoking the analyzer controller and services.

### Entry points

- `Analyzer` controller handlers in `apps/micro-services/resume-analyzer/pkg/api/controllers` process analysis requests and call `Analysis` service methods.
- The OpenAPI spec generator entry point is `apps/micro-services/resume-analyzer/cmd/spec/main.go`.

### Key modules

Core analysis orchestration lives in `apps/micro-services/resume-analyzer/pkg/services/analysis.go`, with analyzers under `apps/micro-services/resume-analyzer/pkg/services/analyzers` and seniority detection under `apps/micro-services/resume-analyzer/pkg/services/senioritydetector`.

### Data sources and sinks

Firestore repositories store analysis results, resumes, and subscriptions, and the service records activity events via `apps/micro-services/resume-analyzer/pkg/services/callers/activitylog.go`.

### Integrations and side effects

The service integrates with Firebase for data access and OpenAI-based seniority detection, and it sends activity logs for resume score events.

### Constraints and risks

Analysis accuracy depends on external LLM responses and Firestore availability, and enterprise endpoints bypass some ownership checks.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Added the OpenAPI spec generator entry point.
- 2026-01-30: Initial documentation.
